import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedDealer, setSelectedDealer } from 'redux/slices/dealerSlice';
import { DealerLocatorContainer } from 'components/DealerLocator/DealerLocatorContainer/DealerLocatorContainer';
import { DealerInfo } from 'components/DealerLocator/DealerInfo/DealerInfo';
import { Dealer, IDealerLocatorContainer } from 'interfaces/dealerLocator';
import { selectZipcode } from 'redux/slices/zipcodeSlice';
import { useDealerLocatorDealers } from 'hooks/useDealerLocatorData';

export function DealerLocator(props: IDealerLocatorContainer): JSX.Element {
  const dealerLockID = sessionStorage.getItem('dealerLockID');
  const dealerID = sessionStorage.getItem('dealerID');
  const dispatch = useDispatch(); // redux dispatch
  const zipcode = useSelector(selectZipcode);
  const dealersFetch = useDealerLocatorDealers(zipcode, undefined);

  if (dealerLockID && dealerID) {
    const dealerList = dealersFetch?.data;
    const dealer = dealerList?.find(
      (dealer: Dealer) => dealer.dealerNumber === dealerID
    );

    if (dealer) {
      dispatch(setSelectedDealer(dealer));
    }
  }

  const currentSelectedDealer = useSelector(selectedDealer);
  if (currentSelectedDealer && props.isEmbedded) {
    return (
      <DealerInfo
        dealer={currentSelectedDealer}
        hideChangeDealer={props.hideChangeDealer}
      />
    );
  } else {
    return <DealerLocatorContainer {...props} />;
  }
}
